export default __webpack_public_path__ + "static/media/eye_visible.60e05668.svg";